import React, { Component } from 'react';

import def from "../assets/images/def-big.gif";
import gscroll from "../assets/images/scroll.gif";
import satheesh from "../assets/images/satheesh.jpg";
import rajath from "../assets/images/rajath.jpg";
import sreekanth from "../assets/images/sreekanth.jpg";
import jilu from "../assets/images/jilu.jpg";
import karthika from "../assets/images/karthika.jpg";
import jobs from "../assets/images/jobs.jpg";
import jobshover from "../assets/images/jobs-hover.jpg";

class About extends Component {
  render() {
    return (
       
    <section className="aboutuspage">


     <div className="width-100">
        <img src={def} className="img-responsive " alt="Web Designing" />  
      </div>
      <img src={gscroll} className="scroll-pos hidden-xs hidden-sm" alt="Development" />

            <div className="container-fluid null-p">

        <div className="tabbable-panel">

          <div className="col-md-12  col-sm-12 col-xs-12  add-m-btm-50">
            <div className="col-md-8 col-md-offset-4  col-sm-12 col-xs-12  add-m-btm-50">

              <div id="scroll-pos" className="tabbable-line  ">
                <ul className="nav nav-tabs ">

                  <li className="active">
                    <a href="#ab-garymark" data-toggle="tab">About Garymark</a>
                  </li>
               
                <li>
                  <a href="#ab-mission" data-toggle="tab">Mission &amp; Vision</a>
                </li>
                <li>
                  <a href="#ab-team" data-toggle="tab">Our Team</a>
                </li>

              </ul>
            </div>
          </div>
        </div>


        <div className="tab-content ">

         
          <div   className="tab-pane active" id="ab-garymark">
            <div className="container">
              <div className="myclr hidden-xs">
                <div className="row add-m-top-50 ">

                  <div className="col-md-3 null-p">
                    <article className="first-child">
                      <div className="start">
                        <i className="fa fa-coffee fa-fw fa-5x"></i>
                        <span className="stat-count">200</span>
                      </div>
                      <h4>200+ Coffee Chats</h4>
                      <p  className="stat-label">Drop in anytime for an intimate coffee chat with the Garymark team about your goals.  We'll help you figure out in <b>Design</b> or <b>Development</b> what might be a good fit for your answered questions.</p>
                    </article>
                  </div>

                  <div className="col-md-3 null-p">
                    <article >
                      <div className="start">
                        <i className="fa fa-code fa-fw fa-5x"></i>
                        <span className="stat-count">100</span>
                      </div>
                      <h4>100+ Projects Completed</h4>
                      <p  className="stat-label">We  maintain trusting, mutually beneficial relationships with our clients. We offer professional solutions for your online business needs. </p>
                    </article>
                  </div>

                  <div className="col-md-3 null-p">
                    <article >
                      <div className="start">
                        <i className="fa fa-leaf fa-fw fa-5x"></i>
                        <span className="stat-count">01</span>
                      </div>
                      <h4>01+ Springs Covered</h4>
                      <p  className="stat-label">Our clients are very happy with what we produce. The measurement of our success is based on how happy the clients are at the final result. We take time to listen and to learn what the client wants.  </p>
                    </article>
                  </div>

                  <div className="col-md-3 null-p">
                    <article className="nth-child">
                      <div className="start">
                        <i className="fa fa-smile-o  fa-fw fa-5x"></i>
                        <span className="stat-count">100</span>
                      </div>
                      <h4>100+ Happy Clients</h4>
                      <p  className="stat-label">Our clients are very happy with what we produce. The measurement of our success is based on how happy the clients are at the final result</p>
                    </article>
                  </div>

                </div>
              </div>

           
              <div className="row add-m-btm-50">
                <div className="pagination-centered text-center">
                  <div className="col-md-12 col-xs-12  bor">
                    <h2>Looking For A Perfect Online Partner  For Your Business?</h2>
                    <h3 className="add-m-btm-20">You stumbled to the right place!</h3>
                    <div className="col-md-4 br-j">
                      <p>Garymark Infotech is a multifaceted <a className="seo-link" href="http://garymarkinfotech.com"><b>web technology</b></a> agency located in Ernakulam. We focus on effective and futuristic <b>web designs</b> and allied services that may equip your business or personal needs with professionalism, moral values, and utmost priority. The quality of our work will ensure and enable the clients to grab spotless reputation and best of their deals. Our team follows the customers to lend our fruitful service round the clock. We bring technology and people near to you. We move along with time to take you for a voyage with us to success.</p>
                    </div>
                    <div className="col-md-4 br-j">
                      <p> Enhancing the image, and brand <b>development</b>, be it personal or of your <b>business</b> are the keywords to success. Open up your ideas, thoughts and dreams, Garymark <b>designers</b> will shape them to definite forms yielding magical results. We are never tired of trying till your aspirations are animated. Our designers can create web marvels that will mark your appearance in the crowd of web world. We will make sure you are listened and watched in the noisy, attention seeking multitudes of voices and visuals .</p>


                    </div>
                    <div className="col-md-4 j">
                      <p>We don't simply stop by all these. We are here to help you establish our creative endeavor into the forefront, hosting your websites opening all possibilities of Free, Shared, Dedicated, Managed, Clustered or Cloud hosting.
                        We can help you to make your presence through <b>SEO</b>. We employ algorithmic tactics to establish your digital existence. We can dig deep, search, meticulously watch and adopt the best practices to make you visible.</p>



                      </div>


                    </div>
                  </div>
                </div>




              </div>
            </div>




<div className="tab-pane" id="ab-team">
              <div className="container-fluid  team">
                <div className="row add-m-btm-50">
                  <div className="pagination-centered text-center">
                    <div className="col-md-12 col-xs-12">
                      <h2>Our Engineering Geeks !!</h2><br/>


                      <div className="row"> 
                       
                        <div className="col-md-4">
                          <div className="c">
                           

                            <img alt="Satheesh Thoppil" className="pop cur-pointer" src={satheesh}   data-toggle="modal" data-target="#sathesh-sir-pr" width='120' height='70' />
                            <p> He <i className="fa fa-heart">  's To Interact More Dynamic In his Skills</i></p>
                            <h2 className="add-m-btm-20">Satheesh Thoppil </h2>
                            <p> Marketing Head </p>
                            <p ></p>
                           

                            <div id="sathesh-sir-pr" className="modal fade" role="dialog">
                              <div className="modal-dialog">
                                <div className="modal-content">
                                  <div className="modal-header">
                                  </div>
                                  <div className="modal-body">
                                    <div className="row">
                                      <div className="col-md-12 col-xs-12">
                                        <div className="col-md-4">
                                          <h2>Satheesh Thoppil </h2>
                                          <img className="prof" src={satheesh} alt="Satheesh Thoppil"/>
                                          <p> He <i className="fa fa-heart"> 's To Interact More Dynamic In his Skills</i></p>
                                          <p>Sales &amp; Marketing Head</p>
                                          <p> I moved into marketing 13 years ago and have loved every moment. My combination of practical marketing experience and logical, organised framework makes my combined marketing and project management role a thrilling experience.
                                          </p>
                                        </div>
                                        <div className="col-md-8 ">
                                          <h3>Skill Set</h3>
                                          <p> I thrive on customer service, and always want the best for my clients. Outside of the office, I play guitar, frequent the gym, and practice Zazen meditation</p>
                                          <div className="col-md-12 col-xs-12">
                                            <div className="col-md-6">
                                              <h3>DESIGN SKILLS</h3>
                                              <p className="w80" data-value="80">interpersonal skills. </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">interpersonal skills.  <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Communication Skills. </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100"><span className="skill">Communication Skills <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Numeracy & Analytical Ability.</p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"> <span className="skill">Analytical Ability. <i className="val">90%</i></span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <h3>DEVELOPMENT SKILLS</h3>
                                              <p className="w80" data-value="80">Creativity & Imagination.</p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">Creativity & Imagination. <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Influencing & Negotiation Skills.</p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">Influencing & Negotiation Skills <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Teamwork. </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">Teamwork <i className="val">80%</i></span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <button type="button" className="pure-button"  data-dismiss="modal">Close</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                          </div>
                        </div>
                      
                        <div className="col-md-4">
                          <div className="c">

                        

                            <img alt="Web Page Templates" className="pop cur-pointer" src={rajath}   data-toggle="modal" data-target="#rajath-pr" width='120' height='70' />
                            <p> He <i className="fa fa-heart"> 's To Interact More Creative In his codes</i></p>
                            <h2 className="add-m-btm-20">Rajath Ramachandran </h2>
                            <p>  Technical Head</p>

                           
                            
                            <div id="rajath-pr" className="modal fade" role="dialog">
                              <div className="modal-dialog">
                                <div className="modal-content">
                                  <div className="modal-header">
                                  </div>
                                  <div className="modal-body">
                                    <div className="row">
                                      <div className="col-md-12 col-xs-12">
                                        <div className="col-md-4">
                                          <h2>Rajath Ramachandran </h2>
                                          <img className="prof" src={rajath} alt="Development Company"/>
                                          <p> He <i className="fa fa-heart"> 's To Interact More Creative In his designs</i></p>
                                          <p>Team Head</p>
                                          <p>I will, in fact, claim that the difference between a bad programmer and a good one is whether he considers his code or his data structures more important. Bad programmers worry about the code. Good programmers worry about data structures and their relationships.</p>
                                        </div>
                                        <div className="col-md-8 ">
                                          <h3>Skill Set</h3>
                                          <p>Programming is not a zero-sum game. Teaching something to a fellow programmer doesn't take it away from you. I'm happy to share what I can, because I'm in it for the love of programming.</p>
                                          <div className="col-md-12 col-xs-12">
                                            <div className="col-md-6">
                                              <h3>Front End Development</h3>
                                              <p className="w80" data-value="80">Bootstrap Development</p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">HTML/CSS/JAVASCRIPT  <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Jquery Development </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100"><span className="skill">JQUERY <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Scaffolding Tools </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"> <span className="skill">GRUNT/BOWER/YEOMAN <i className="val">50%</i></span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <h3>Back End Developemt</h3>
                                              <p className="w80" data-value="80">PHP Development </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">PHP/MYSQL  <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Laraval Framework </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">PHP-LARAVAL<i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Codigniter Framework </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">PHP-CODEIGNITER <i className="val">80%</i></span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <button type="button" className="pure-button" data-dismiss="modal">Close</button>
                                    
                                  </div>
                                </div>
                              </div>
                            </div>
                           
                          </div>
                        </div>
                       
                        <div className="col-md-4">
                          <div className="c">
   

                            <img alt="Ui Design" className="pop cur-pointer" src={sreekanth}   data-toggle="modal" data-target="#sreekanth-pr" width='120' height='70' />
                            <p> He <i className="fa fa-heart"> 's To Interact More Creative In his designs</i></p>
                            <h2 className="add-m-btm-20">Sreekanth R Nair </h2>
                            <p>Web Developer</p>
                            <p ></p>
                         
                            <div id="sreekanth-pr" className="modal fade" role="dialog">
                              <div className="modal-dialog">
                                <div className="modal-content">
                                  <div className="modal-header">
                                  </div>
                                  <div className="modal-body">
                                    <div className="row">
                                      <div className="col-md-12 col-xs-12">
                                        <div className="col-md-4">
                                          <h2>Sreekanth R Nair </h2>
                                          <img className="prof" src={sreekanth} alt="sreekanth"/>
                                          <p> He <i className="fa fa-heart"> 's To Interact More Creative In his designs</i></p>
                                          <p>Web Developer</p>
                                          <p>Our biological body itself is a form of hardware that needs re-programming through tantra like a new spiritual software which can release or unblock its potential.</p>
                                        </div>
                                        <div className="col-md-8 ">
                                          <h3>Skill Set</h3>
                                          <p>I have particular level of skill set. That skills,  I have acquired over a long career . I  living in the world of developing ,testing and hacking.</p>
                                          <div className="col-md-12 col-xs-12">
                                            <div className="col-md-6">
                                              <h3>DEVELOPMENT SKILLS</h3>
                                              <p className="w80" data-value="80">Web development</p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">HTML/CSS/PHP <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Laravel </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"><span className="skill">Laravel Framework<i className="val">85%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Scaffolding Tools </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">GRUNT/BOWER/YEOMAN<i className="val">80%</i></span>
                                                </div>
                                              </div>

                                            </div>
                                            <div className="col-md-6">
                                              <h3>TESTING SKILLS</h3>
                                              <p className="w80" data-value="80">Ethical Hacking</p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">Ethical Hacking<i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Penetration testing </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">Penetration testing<i className="val">80%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="80">Software testing </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"> <span className="skill">Software testing <i className="val">90%</i></span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <button type="button" className="pure-button"  data-dismiss="modal">Close</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                          </div>
                        </div>
                        
                      </div>
                       






                      <hr className="style" />
                      <div className="row"> 

                       
                        <div className="col-md-4">
                          <div className="c">
                            

                            <img alt="About us page" className="pop cur-pointer" src={jilu}   data-toggle="modal" data-target="#jilu-ps" width='120' height='70' />
                            <p>She <i className="fa fa-heart"> 's To Interact More Creative In her designs</i></p>
                            <h2 className="add-m-btm-20">Jilu PS </h2>
                            <p>Senior Web Developer</p>
                            <p ></p>
                            
                            <div id="jilu-ps" className="modal fade" role="dialog">
                              <div className="modal-dialog">
                                <div className="modal-content">
                                  <div className="modal-header">
                                  </div>

                                  <div className="modal-body">
                                    <div className="row">
                                      <div className="col-md-12 col-xs-12">
                                        <div className="col-md-4">
                                          <h2>Jilu P.S</h2>
                                          <img className="prof" src={jilu} alt="Website Designing"/>

                                          <p>She <i className="fa fa-heart"> 's To Interact More Creative In her skills</i></p>
                                          <p>Web Developer</p>
                                          <p>"I Love my job .I Work hard ,To build a career out of my passion. To find my place in this amazing world ..To inspire you to think about where you want your life to go !!"</p>
                                        </div>
                                        <div className="col-md-8 ">
                                          <h3>Skill Set</h3>
                                          <p>I love programming and love systems. So I just figured in this perfect combination . And my favorite quote is "work until your idols become your rivals" . </p>
                                          <div className="col-md-12 col-xs-12">
                                            <div className="col-md-6">
                                              <h3>Front End Development</h3>
                                              <p className="w80" data-value="80">Bootsrap Development </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">HTML/CSS/JAVASCRIPT  <i className="val">80%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="95">Jquery Development </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100"><span className="skill">JQUERY/AJAX <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="70">Scaffolding Tools  </p>
                                              <div className="progress skill-bar ">                                          
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"> <span className="skill">GRUNT/BOWER/YEOMAN <i className="val">60%</i></span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <h3>Back End Development</h3>
                                              <p className="w80" data-value="95">PHP Development</p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">PHP <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="95">CODEIGNITER FRAMEWORK </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">CODEIGNITER/HMVC  <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="100">MYSQL </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">MYSQL <i className="val">100%</i></span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <button type="button" className="pure-button" data-dismiss="modal">Close</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                           
                          </div>
                        </div>
                       



                       
                        <div className="col-md-4">
                          <div className="c">
                           
                            <img alt="About us page" className="pop cur-pointer" src={karthika}   data-toggle="modal" data-target="#karthika-j" width='120' height='70' />
                            <p>She <i className="fa fa-heart"> 's To Interact More Creative In her designs</i></p>
                            <h2 className="add-m-btm-20">Jilu PS </h2>
                            <p>Senior SEO Analyst</p>
                            <p ></p>
                            
                            <div id="karthika-j" className="modal fade" role="dialog">
                              <div className="modal-dialog">
                                <div className="modal-content">
                                  <div className="modal-header">
                                  </div>

                                  <div className="modal-body">
                                    <div className="row">
                                      <div className="col-md-12 col-xs-12">
                                        <div className="col-md-4">
                                          <h2>Karthika Jayan</h2>
                                          <img className="prof" src={karthika} alt="Website Designing"/>

                                          <p>She <i className="fa fa-heart"> 's To Interact More Creative In her skills</i></p>
                                          <p>Web Developer</p>
                                          <p>"I Love my job .I Work hard ,To build a career out of my passion. To find my place in this amazing world ..To inspire you to think about where you want your life to go !!"</p>
                                        </div>
                                        <div className="col-md-8 ">
                                          <h3>Skill Set</h3>
                                          <p>I love programming and love systems. So I just figured in this perfect combination . And my favorite quote is "work until your idols become your rivals" . </p>
                                          <div className="col-md-12 col-xs-12">
                                            <div className="col-md-6">
                                              <h3>Front End Development</h3>
                                              <p className="w80" data-value="80">Bootsrap Development </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">HTML/CSS/JAVASCRIPT  <i className="val">80%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="95">Jquery Development </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100"><span className="skill">JQUERY/AJAX <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="70">Scaffolding Tools  </p>
                                              <div className="progress skill-bar ">                                          
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"> <span className="skill">GRUNT/BOWER/YEOMAN <i className="val">60%</i></span>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <h3>Back End Development</h3>
                                              <p className="w80" data-value="95">PHP Development</p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">PHP <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="95">CODEIGNITER FRAMEWORK </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">CODEIGNITER/HMVC  <i className="val">95%</i></span>
                                                </div>
                                              </div>
                                              <p className="w80" data-value="100">MYSQL </p>
                                              <div className="progress skill-bar ">
                                                <div className="progress-bar  progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                                                  <span className="skill">MYSQL <i className="val">100%</i></span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <button type="button" className="pure-button" data-dismiss="modal">Close</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                          </div>
                        </div>
                      
                        <div className="col-md-4">
                          <div className="c">
                           

                            <img alt="Ui Design" className="pop cur-pointer" src={jobs}   data-toggle="modal" data-target="#opening-pr" width='120' height='70' onmouseover="this.src={jobshover}" onmouseout="this.src={jobs}" />
                            <p>Apply Here For Current Opening</p>
                            <h2 className="add-m-btm-20">YOU? </h2>

                            <p ></p>
                           

                            <div id="opening-pr" className="modal fade" role="dialog">
                              <div className="modal-dialog">
                                <div className="modal-content">
                                  <div className="modal-header">
                                  </div>
                                  <div className="modal-body">
                                    <div className="row">
                                      <div className="col-md-12 col-xs-12">
                                        <div className="col-md-4">
                                          <h2>You  </h2>
                                          <img className="prof" src={jobs} alt="sreekanth"/>


                                          
                                        </div>
                                        <div className="col-md-8 ">
                                                                              <p>You have a particular level of skill  that matching our profile there over a long career . You are living in the world of developing ,testing and hacking.</p>
                                        <div className="col-md-12 col-xs-12">

                                          <p>Send your Resume <a className="mails" href="mailto:hr@garymarkinfotech.com?Subject=Resume" target="_top">hr@garymarkinfotech.com</a> </p>
                                          <ul className="my-list">
                                            <li><i className="fa fa-fw fa-angle-double-right"></i><b>UI developer</b>-SUBJECT CODE:[GMI-UID] </li>
                                            <li><i className="fa fa-fw fa-angle-double-right"></i><b>Laravel Developer</b>-SUBJECT CODE:[GMI-LD]</li>
                                            <li><i className="fa fa-fw fa-angle-double-right"></i><b>Codignator Developer</b>- SUBJECT CODE:[GMI-CD]  </li>
                                            <li><i className="fa fa-fw fa-angle-double-right"></i><b>Content Writer</b>- SUBJECT CODE:[GMI-JCD]</li>
                                            <li><i className="fa fa-fw fa-angle-double-right"></i><b>SEO Analyst</b>- SUBJECT CODE: [GMI-UID]</li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <button type="button" className="pure-button"  data-dismiss="modal">Close</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                       
                      </div>
                      

                      
                      <hr className="style" />
                      <div className="row">




                        
                      </div>
                      


                      
                    </div>

                     




                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="tab-pane" id="ab-mission">
            <div className="container-fluid">
              
              <div className="row add-m-btm-50">
                <div className="pagination-centered text-center">

                  <h2>We engineer meaningful technology solutions to<br/> help businesses and societies flourish. </h2>

                  <div className="row add-m-top-50">
                    <div className="col-md-12">
                                    
                                  <div className="col-md-4">
                                    <h3>UNRELENTING DEDICATION</h3><hr className="style" />

                                    <p>Garymark is driven to meet client needs with determination and grit. We embrace tough challenges and do not rest until the problem is solved, the right way.</p>


                                  </div>
                                  <div className="col-md-4">
                                    <h3>COLLABORATIVE SPIRIT  </h3><hr className="style" />
                                    <p>Garymark believes in developing true partnerships. We foster a collegial environment where individual perspectives are respected and honest dialogue is expected</p>
                                  </div>
                                  <div className="col-md-4">
                                    <h3>EXPERT THINKING</h3><hr className="style" />
                                    <p>Garymark brings robust skills and forward looking perspectives to solve customer challenges. We use proven knowledge to make recommendations and provide expert guidance to our customers.</p>
                                  </div>


                                </div>

                              </div>

                            </div>
                          </div>




                        </div>
                      </div>


                    <div className="tab-pane" id="ab-team">

                       
                        <div className="row ">
                          <div className="pagination-centered text-center">


                            <div className=" founder-2 col-md-12 col-xs-12 ">
                              <div className="col-md-6 add-m-top-175">  
                                <img src="images/founder-small2.jpg"  className="img-responsive hidden-lg hidden-md" alt="Founders"/>





                                <h2>T S MAHESH</h2>

                                <div className="row">
                                  <p>
                                    Hotelier by profession, Mahesh started life at Taj Hotels in 1994 after studying Post Graduation in Hospitality Management. After his successful career in Hotel 
                                    industry he entered into business. In 2011 he founded <b>Rudrahospitality Services</b>. with 
                                    Mr.Jayakrishnan and leads the team .
                                    In February 2015 Garymark was launched to help small to medium sized businesses achieve a presence on the Internet. The sites grew from 0 to 50 clients within 1 year.</p>

                                  </div>
                                </div>
                                <div className="col-md-6">  </div>
                              </div>
                              <div className=" founder-2 col-md-12 col-xs-12 ">
                                <div className="col-md-6">  </div>
                                <div className="col-md-6 add-m-top-175">  




                                  <img src="images/founder-small1.jpg"  className="img-responsive hidden-lg hidden-md" alt="Founders"/>
                                  <h2>JAYAKRISHNAN G</h2>

                                  <div className="row">
                                    <p>The co-founder of <b>Rudrahospitality</b> with an experience of 17 Yrs in 
                                      Hospitality industry in different management positions is responsible for managing 
                                      the business and developing relationships with partners and customers.
                                      After gaining an MBA in Hotel Management, He was working in 4 star deluxe hotels from 
                                      1999. Later he joined with Mahesh and entered into hospitality business. </p>


                                    </div>
                                  </div>
                                </div>



                              </div>
                            </div>

                          </div>
            </div>
















        </div>
        </div>



      </section>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.js